import { render, staticRenderFns } from "./DataShareUserList.vue?vue&type=template&id=25339d25&"
import script from "./DataShareUserList.vue?vue&type=script&lang=js&"
export * from "./DataShareUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports